import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BASEURL } from "../../configure";
import ImgContainer from "./img";

const Para = styled.span`
  font-family: "Poppins-SemiBold";
  color: black;
  font-size: 15px;
  @media screen and (max-width: 599px) {
    font-size: 15px;
  }
  @media screen and (max-width: 382px) {
    font-size: 12px;
  }
`
export default function Cast(props) {
  const { cast } = props; 
  const [ getCastData, setCastData ] = useState('')
  
    useEffect(() => {
      setCastData(()=>{
        
      })
    },[cast])
    if (cast) {
      
      return (
        cast.map((data, ind) => { 
          return (
            <Grid item xs={3} key={ind} justifyContent="center">
              <ImgContainer imgId={data.id} />
              {/* <img src={getPrjectDetails()} style={{ width: "100%", height: "auto", maxHeight: "140px", objectFit: "cover" }}/> */}
              <br></br>
              <Para>{data?.name}</Para>
            </Grid>
            )
        }) 
      )
    }
    
  }
  
  
